declare global {
  interface Window {
    __ENV__?: {
      VITE_API_URL?: string;
    };
  }
}

const configuredApiUrl = window.__ENV__?.VITE_API_URL || import.meta.env.VITE_API_URL;

if (!configuredApiUrl) {
  throw new Error('VITE_API_URL is required');
}

export const API_BASE_URL = configuredApiUrl.replace(/\/+$/, '');
